import Vue from 'vue'
import Navigation from './navigation'
import NdButton from '../nd-button'
import store from '../../store'
import router from '../../router'
import './index.less'
import { camelCase, preLoadImage, getKey } from '@/assets/utils'
import { naBridge } from '@/assets/jsBridge'
import { PullRefresh } from 'vant'
import PullDownPage from '../pulldown-page'
import pLI1 from './images/loading01.png'
import pLI2 from './images/loading02.png'
import pLI3 from './images/pic_network_anomaly.png'
import Lottie from 'vue-lottie'
import animationData from '../nd-indicator/images/loading.json'

preLoadImage([pLI1, pLI2, pLI3])

const vm = Vue.prototype.$bus = new Vue({})

Vue.use(PullRefresh)
Vue.component('pulldown-page', PullDownPage)

const loadingTemplate = new Vue({
  data () {
    return {
      loading: 'image1',
      text: '正在加载中...'
    }
  },

  components: {
    'lottie': Lottie
  },

  render (h, params) {
    return h('pulldown-page', {
      class: 'nd-loading',
      props: {
        background: '#FFFFFF',
        color: '#333333',
        refresh: () => {
          // window.location.reload()
        }
      }
    }, [
      h('div', {
        class: ['loading-image']
      }, [
        h('lottie', {
          ref: 'animataion',
          props: {
            options: {
              animationData: animationData
            }
          }
        })
      ]),
      h('p', this.text)
    ])
  },
  router,
  store
}).$mount()
const errorTemplate = new Vue({
  components: {
    Navigation,
    NdButton
  },
  render: h => h('pulldown-page', {
    class: 'nd-error',
    props: {
      background: '#FFFFFF',
      color: '#333333',
      refresh: () => {
        window.location.reload()
      }
    }
  }, [
    !['API-XHQB', 'API-WEIBO'].includes(getKey('channel')) ? h('navigation', '网络异常') : h('div', { class: 'error-title' }),
    h('div', {
      class: 'error-image'
    }, ''),
    h('p', '网络走丢了'),
    h('p', [
      h('span', '～~请确认网络是否正常连接～~')
    ], ''),
    h('nd-button', {
      class: 'btn refresh-btn',
      on: {
        click () {
          window.location.reload()
        }
      }
    }, '刷新页面')
  ]),
  // 必须引入router，否则没办法后退
  router,
  store
}).$mount()

const $loading = document.createElement('div')

function init () {
  console.log('init')
  vm.$bus.$emit('loading')
  $loading.innerHTML = ''
  $loading.appendChild(loadingTemplate.$el)
  Vue.prototype.$bus.$on('ready', ready)
  Vue.prototype.$bus.$on('error', error)
  $loading.className = 'loading-indicator'
  document.body.appendChild($loading)
}

function ready () {
  clearTimeout(errorTimer)
  errorTimer = null
  $loading.className = 'loading-indicator loaded'
  setTimeout(() => {
    $loading.parentNode && $loading.parentNode.removeChild($loading)
  }, 300)
}

function error () {
  clearTimeout(errorTimer)
  errorTimer = null
  let indicator = document.getElementsByClassName('loading-indicator')[0]
  if (!indicator) {
    $loading.className = 'loading-indicator'
    document.body.appendChild($loading)
    indicator = document.getElementsByClassName('loading-indicator')[0]
  }
  indicator.innerHTML = ''
  indicator.appendChild(errorTemplate.$el)
}

function errorHandler () {
  return setTimeout(() => {
    const indicator = document.getElementsByClassName('loading-indicator')[0]
    if (indicator) {
      indicator.innerHTML = ''
      indicator.appendChild(errorTemplate.$el)
    }
  }, 10e3 * 1.5)
}

function routeNullHandle () {
  clearTimeout(errorTimer)
  errorTimer = null

  const indicator = document.getElementsByClassName('loading-indicator')[0]
  if (indicator) {
    indicator.innerHTML = ''
    indicator.appendChild(errorTemplate.$el)
  }
}

init()
var errorTimer = errorHandler()

export default {
  install (Vue) {
    Vue.mixin({
      beforeRouteLeave (to, from, next) {
        init()
        if (to.name === null) {
          routeNullHandle()
        } else {
          errorTimer = errorHandler()
        }
        next()
      },

      created () {
        if (!this.$route) return
        const { token } = this.$route.query || {}
        if (token) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
          let obj = { ...userInfo, token }
          localStorage.setItem('userInfo', JSON.stringify(obj))
        }
        if (this.$route.name === null && this.$route.path !== '/') {
          routeNullHandle()
        }

        const nativeBackInterceptor = this.$options.nativeBackInterceptor
        if (nativeBackInterceptor && this.$route.name && this.$route.name === camelCase(this.$options.name)) {
          let cb
          if (typeof nativeBackInterceptor === 'boolean') {
            cb = () => {
              this.$bus.$emit('nativeBack')
              return true
            }
          } else if (typeof nativeBackInterceptor === 'function') {
            cb = nativeBackInterceptor.bind(this)
          }
          naBridge('goBack', cb)
        }

        if (!this.$options.customReadyNotify && this.$route.name && this.$route.name === camelCase(this.$options.name)) {
          this.$nextTick(() => {
            this.$bus.$emit('ready')
          })
        }
      }
    })
  }
}
